/* eslint-disable @nx/enforce-module-boundaries */
import { Tab, TabList, Tabs } from '@mybridge/ui/tabs';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { css } from '@chakra-ui/react';
import { isMobile } from 'react-device-detect';
import { Menu, MenuButton, MenuItem, MenuList } from '@mybridge/ui';
import { ThreeDotsIcon } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const ProfileTabsArray = [
  {
    title: 'Post',
    translationKey: 'profile.post',
    link: '/profile/me',
  },
  ...([
        {
          title: 'About',
          translationKey: 'profile.about',
          link: '/profile/about',
        },
      ]
    ),
  // {
  //   title: 'myNetwork',
  //   link: '/profile/network',
  // },
  {
    title: 'Photos',
    translationKey: 'profile.photos',
    link: '/profile/photos',
  },
  {
    title: 'Videos',
    translationKey: 'profile.videos',
    link: '/profile/videos',
  },
  // {
  //   title: 'myCalendar',
  //   link: '/profile/calendar',
  // },
  // {
  //   title: 'myDisk',
  //   link: '/profile/disk',
  // },
];

export const ProfileTabs = ({ active = 0, ...props }) => {
  const { t } = useTranslator();
  return (
    <>
      {isMobile ? (
        <Tabs index={active} mb="-1px" >
          <TabList borderBottomColor="transparent" {...props}>
            {ProfileTabsArray.map((t, index) => (
              <Link key={index} href={`${t?.link}`}>
                <Tab>{t?.title}</Tab>
              </Link>
            ))}
          </TabList>
        </Tabs>
      ) : (
        <Tabs index={active} mb="-1px" >
          <TabList borderBottomColor="transparent" {...props}>
            {ProfileTabsArray.map((tab, index) => (
              <Link key={index} href={`${tab?.link}`}>
                <Tab>{t(tab.translationKey) || tab?.title}</Tab>
              </Link>
            ))}
          </TabList>
        </Tabs>
      )}
    </>
  );
};

export default ProfileTabs;
